import { BREAKPOINTS } from '@/types';

export const supportsTouchScreen: () => boolean = () => {
  return !!('ontouchstart' in window);
};

export const getSmallScreenMatchMedia = (): MediaQueryList =>
  window.matchMedia(`(max-width: ${BREAKPOINTS.domus_md - 1}px)`); // ≤767px

export const getLargeScreenMatchMedia = (): MediaQueryList =>
  window.matchMedia(`(min-width: ${BREAKPOINTS.domus_lg}px)`); // ≥1024px

export const isNavigableAnchor = (anchor: HTMLAnchorElement): boolean => {
  const href = anchor.getAttribute('href');

  return Boolean(
    href &&
    !href.startsWith('#') &&
    !href.startsWith('mailto:') &&
    !href.startsWith('tel:') &&
    anchor.target !== '_blank',
  );
};
